'use client';

import { createIntl } from '@formatjs/intl';
import { userAgent } from 'next/server';
import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import type { Bootstrap } from '@alltrails/networking/types/Bootstrap';
import type CountryCode from '@alltrails/types/CountryCode';
import type Experiments from '@alltrails/types/Experiments';
import { buildStore } from '../utils/redux';

type Props = {
  bootstrap: Bootstrap;
  browser: ReturnType<typeof userAgent>['browser'];
  experiments: Experiments;
  messages: ReturnType<typeof createIntl>['messages'];
  locale: ReturnType<typeof createIntl>['locale'];
  irclickid?: string;
  requestCountryCode: CountryCode;
};

export default function CustomProvider({
  bootstrap,
  browser,
  experiments,
  messages,
  locale,
  children,
  irclickid,
  requestCountryCode
}: PropsWithChildren<Props>) {
  const store = buildStore({
    amplitudeAnalyticsSettings: bootstrap.amplitudeAnalyticsSettings,
    browser,
    context: bootstrap.context,
    currencyCode: bootstrap.currencyCode,
    experiments,
    features: bootstrap.features,
    irclickid,
    plans: bootstrap.plans,
    requestCountryCode
  });

  return (
    <IntlProvider messages={messages} locale={locale}>
      <Provider store={store}>{children}</Provider>
    </IntlProvider>
  );
}
